import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatDateTime } from '../../utils/parsing';
import {
    COLOR_CHAT_EVENT_TEXT,
    COLOR_OWN_CHAT_MESSAGE_BG,
    COLOR_OTHERS_CHAT_MESSAGE_BG,
    COLOR_CHAT_EVENT_BG,
    COLOR_CHAT_MESSAGE_TEXT
} from '../../theme';
import { OfferMessageType } from '../../types/OfferMessageType';

type PropsType = {
    isCurrentTenant: boolean;
    offerTenantId?: number;
    userName: string;
    createdAt: string;
    message: string;
    isEvent: boolean;
    readBy: OfferMessageType['readBy'];
}

export default function OfferChatMessage({
    isCurrentTenant,
    offerTenantId,
    userName,
    createdAt,
    message,
    isEvent,
    readBy
}: PropsType) {
    return (
        <>
            <Box
                sx={{
                    maxWidth: '90%',
                    ...(isCurrentTenant ? { marginLeft: 'auto' } : {}),
                    borderRadius: '5px',
                    // eslint-disable-next-line no-nested-ternary
                    backgroundColor: isEvent ? COLOR_CHAT_EVENT_BG : (
                        isCurrentTenant ? COLOR_OWN_CHAT_MESSAGE_BG : COLOR_OTHERS_CHAT_MESSAGE_BG
                    ),
                    // eslint-disable-next-line no-nested-ternary
                    color: isEvent ? COLOR_CHAT_EVENT_TEXT : (
                        isCurrentTenant ? COLOR_CHAT_MESSAGE_TEXT : undefined
                    ),

                    marginBottom: 1,
                    padding: '5px 12px 3px 12px'
                }}
                display="table"
            >
                {message.split('\n').map((part, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Typography display="block" key={i} sx={{ fontWeight: isEvent ? '500' : undefined }}>
                        {part}
                    </Typography>
                ))}
                <Typography variant="caption" display="block">
                    {`${userName}, ${formatDateTime(createdAt)}`}
                </Typography>
            </Box>
            {readBy?.map((rb) => (
                <Typography
                    variant="caption"
                    display="block"
                    textAlign={rb.tenantId === offerTenantId ? 'left' : 'right'}
                    key={rb.userId}
                >
                    {`${rb.userName}, ${formatDateTime(rb.lastRead)}`}
                </Typography>
            ))}
        </>
    );
}
/*

*/
